<template>
    <v-data-table
        :headers="headers"
        :items="items"
        :options.sync="options"
        class="elevation-1"
        :sort-by="'created_at'"
        :sort-desc="true"
        :loading="loading"
        :server-items-length="itemsTotal"
        :footer-props="{itemsPerPageOptions : $root.OPTIONS_PER_PAGE_DATATABLE}"
        @update:options="listar"
    >
        <template v-slot:item.id="{item}">
            {{ $_str_pad_left(item.id) }}
        </template>
        <template v-slot:item.monto="{item}">
            {{ $_currency(item.monto) }}
        </template>
        <template v-slot:body.append="props">
            <tr>
                <td colspan="2" class="text-right"><v-row>
                    <v-col>{{textRagoFechas}}</v-col>
                    <div class="flex-grow-1"></div>
                    <v-col>
                        Total página:
                    </v-col>
                </v-row></td>
                <td class="text-right font-weight-bold">{{$_currency(montoTotalPorPagina)}}</td>
            </tr>
        </template>
    </v-data-table>
</template>

<script>
    import axios from 'axios';
    import EventBus from "@/EventBus";
    export default {
        name: "RecompensaPorComprarSaldo",
        props : {
            filter : {
                type : Object,
                default : () => {
                    return {
                        desde : null,
                        hasta : null
                    }
                }
            }
        },
        data(){
            return {
                headers : [
                    {
                        text: 'Nº cliente',
                        align: 'center',
                        sortable: false,
                        value: 'cliente.id',
                        width: '30px'
                    },
                    {
                        text: 'Cliente',
                        align: 'left',
                        sortable: false,
                        value: 'cliente.nombre',
                        width: '150px'
                    },
                    {
                        text: 'Monto',
                        align: 'right',
                        sortable: false,
                        value: 'monto',
                        width : '50px'
                    },
                ],
                items : [],
                itemsTotal : 0,
                loading : false,
                options: {
                    descending: true,
                    page: 1,
                    itemsPerPage: this.$root.OPTIONS_PER_PAGE_DATATABLE[0],
                    totalItems: 0
                },
            }
        },
        computed : {
            montoTotalPorPagina(){
                return this.items.reduce((total, item) => {
                    return item.monto ? total + parseFloat(item.monto) : total;
                }, 0);
            },
            textRagoFechas(){
                let text = '';
                if(this.filter.desde === null && this.filter.hasta === null){
                    text = 'Mostrando las recompensa aplicadas el último mes';
                }
                return text;
            }
        },
        methods : {
            listar(){
                if(this.loading === false){
                    let url ='/api/reportes/recompensa-monedero-comprar-saldo';
                    if(this.filter.export){
                        url = `${url}/export`;
                    }
                    this.loading = true;
                    const {sortBy, sortDesc, page, itemsPerPage} = this.options;
                    axios.get(url, {
                        params: {
                            sortBy: sortBy, sortDesc: sortDesc, page: page, rowsPerPage: itemsPerPage,
                            search: this.search,
                            ...this.filter
                        }
                    })
                        .then(({data,request}) => {
                            this.loading = false;
                            if(this.filter.export){
                                const win = window.open(request.responseURL, '_blank');
                                win.focus();
                                this.$emit("export-file");
                                return;
                            }
                            this.items = data.data;
                            this.itemsTotal = data.total;
                            this.options.page = data.current_page;
                        })
                        .catch(() => {
                            this.loading = false;
                            EventBus.$emit('tugarrafon:show-snackbar', {
                                color: 'error',
                                multi_line: true,
                                text_content: 'Ocurrió un error al procesar la solicitud, el reporte de recompensas por compra de saldo no se cargó correctamente'
                            });
                        })
                }
            }
        },
        watch : {
            filter : {
                handler : 'listar',
                deep : true,
                inmediate : true
            }
        }
    }
</script>

<style scoped>

</style>
